export default __webpack_public_path__ + "static/Home-375-31aee8e23df67e9a327887e0c61bb41d.webp";